import { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './omakasePlanBanner.module.scss';
import bannerImage from '../../../../assets/omakasePlanImages/omakasePlanBannerImage.png';

const OmakasePlanBanner = ({ onClick }) => {
  return (
    <button className={styles.button} type="button" onClick={onClick}>
      <img src={bannerImage} alt="bannerImages" className={styles.bannerImage} />
    </button>
  );
};

OmakasePlanBanner.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default memo(OmakasePlanBanner);
